import { render } from "./carrusel3_ingles.vue?vue&type=template&id=7c75f2d2&scoped=true"
import script from "./carrusel3_ingles.vue?vue&type=script&lang=js"
export * from "./carrusel3_ingles.vue?vue&type=script&lang=js"

import "./carrusel3_ingles.vue?vue&type=style&index=0&id=7c75f2d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c75f2d2"]])

export default __exports__